import React from 'react';
import Feature from '../../components/Feature/Feature';
import './Features.css';

const featuresData = [
  {
    title: 'Assisting in writable content',
    text: 'GPT-4 has been used to generate articles, poems, stories, news reports, and dialogue from a tiny quantity of input text, which may then be utilised to generate enormous amounts of content.',
  },
  {
    title: "In developer's asset",
    text: 'GPT-4 can generate any text structure, not only human language text. It can also provide written summaries and programming code.',
  },
  {
    title: 'Entertainment?',
    text: 'It generate memes, quizzes, recipes, comic strips, jokes, scripts, music, and so on.',
  },
];

const Features = () => (
  <div className="gpt3__features section__padding" id="features">
    <div className="gpt3__features-heading">
      <h1 className="gradient__text">The Future is Now and You Just Need to Realize It. Step into Future Today. & Make it Happen.</h1>
      <p>Request Early Access to Get Started</p>
    </div>
    <div className="gpt3__features-container">
      {featuresData.map((item, index) => (
        <Feature title={item.title} text={item.text} key={item.title + index} />
      ))}
    </div>
  </div>
);

export default Features;